export const PLATFORM_TYPE = {
    1: 'PC端',
    2: '移动端',
};

export const BANNER_TYPE = {
    1: '首页',
    2: '活动',
    3: '理财',
    4: 'BTC减产',
    5: '杠杆代币',
    6: 'LT公用',
    7: '首页主推',
    8: '首页常驻',
    9: '首页精选',
    10: '新币上线',
    11: '板块banner',
    12: '新理财banner',
    13: '活期宝',
    14: 'IPFS云算力',
    15: 'IPFS云算力1(web)',
    16: 'IPFS云算力2(web)',
    17: '锁仓挖矿',
    18: '活动视频-官网首页',
    19: '活动视频-七折抢购 ',
    20: '活动视频-HASH夺宝 ',
    21: '活动视频-交易挖矿',
    22: '活动视频-随机免单'
};

export const POSITION_TYPE = {
    1: '广告位一',
    2: '广告位二',
    3: '广告位三',
    4: '广告位四',
    5: '广告位五',
    6: '广告位六',
    7: '广告位七',
    8: '广告位八',
    9: '广告位九',
    10: '广告位十'
};

export const SIZE_TIPS = {
    s7: '750 x 400px',
    s8: '686 x 140px',
    s9: '335 x 150px',
    s10: '686 x 307px',
    s11: '686 x 140px',
    s12: '686 x 140px',
    s14: '686 x 140px',
}
